var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9868 6.07898C18.0374 4.97345 17.5141 3.55368 17.5145 2.08398H13.2229V19.6507C13.1898 20.6013 12.7963 21.5017 12.1253 22.1623C11.4543 22.8229 10.5582 23.1922 9.62565 23.1923C7.65343 23.1923 6.01454 21.549 6.01454 19.509C6.01454 17.0723 8.3201 15.2448 10.6951 15.9957V11.519C5.90343 10.8673 1.70898 14.664 1.70898 19.509C1.70898 24.2265 5.54232 27.584 9.61176 27.584C13.9729 27.584 17.5145 23.9715 17.5145 19.509V10.5982C19.2548 11.8729 21.3442 12.5569 23.4868 12.5532V8.17565C23.4868 8.17565 20.8757 8.30315 18.9868 6.07898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokWhite);
export default __webpack_public_path__ + "static/media/tiktokWhite.722cd6ac086ba69ada545db189383c99.svg";
export { ForwardRef as ReactComponent };